import { firestore } from 'firebase/app';
import { useEffect, useState } from 'react';
import { SpDocument } from '../domain/document';
import { useSession } from './use-session';
import { snapshotToDocument } from '../helpers';

export function useCollection<T extends SpDocument>() {
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState<T[]>([]);
  const [collection, setCollection] = useState<firestore.CollectionReference | null>(null);
  const { user } = useSession();

  useEffect(
    () => {
      const coll = firestore()
        .collection('userData')
        .doc(user?.uid)
        .collection('relics')
      setCollection(coll);
      const unsubscribe = coll
        .onSnapshot(collection => {
          setLoading(false);
          const docs: T[] = [];
          collection.forEach(doc => docs.push(snapshotToDocument(doc)));
          setDocuments(docs);
        }, error => {
          setError(error);
        });
      return () => unsubscribe();

    }, [user]
  )

  return {
    error,
    loading,
    collection,
    documents
  }
}